import React from 'react';
import { Col } from 'antd';
import COButton from 'shared/components/COButton';
import { ReactComponent as AddIcon } from 'assets/icons/add_enclosed.svg';
import { ButtonLabels, RawMaterialProps } from 'enums/RawMaterialEnums';
import styles from '../CreateProductFlow.module.scss';
import { FormikProps } from 'formik';
import { rawMaterialPayload } from 'views/CreateProductFlow/CreateProductFlowInterfaces';

interface AddOriginButtonProps {
  isDisabled: boolean;
  formikProps: FormikProps<rawMaterialPayload>;
  index: number;
  handleAddOrigins: (
    formikProps: FormikProps<rawMaterialPayload>,
    index: number,
    type?: string,
    id?: string
  ) => void;
}

const AddOriginButton: React.FC<AddOriginButtonProps> = ({
  isDisabled,
  formikProps,
  index,
  handleAddOrigins,
}) => {
  return (
    <div
      className={styles.buttonFieldRow}
      key={`${RawMaterialProps.INGREDIENTS}-${RawMaterialProps.ADD_ORIGIN_BUTTON}-${index}`}
      id={`${RawMaterialProps.INGREDIENTS}-${RawMaterialProps.ADD_ORIGIN_BUTTON}-${index}`}>
      <div className={styles.numberEmptyContainer}></div>
      <div className={styles.ingredientFieldContainer}></div>
      <Col>
        <COButton
          text
          disabled={isDisabled}
          onClick={() =>
            handleAddOrigins(
              formikProps,
              index,
              RawMaterialProps.INGREDIENT,
              `${RawMaterialProps.INGREDIENTS}-${RawMaterialProps.ADD_ORIGIN_BUTTON}-${index}`
            )
          }>
          <AddIcon />
          {ButtonLabels.ADD_ORIGIN}
        </COButton>
      </Col>
    </div>
  );
};

export default AddOriginButton;
